module.exports = __webpack_public_path__ + "static/img/mac.9a3aaeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/mac.png
// module id = fPQ8
// module chunks = 70